export default function parseEagleeyeId(eagleeyeId) {
    if (!eagleeyeId || typeof eagleeyeId !== "string" || eagleeyeId.length < 21) {
        return {
            aserver: "",
            traceTime: ""
        };
    }
    var i = 0;
    var ipArr = new Array(4);
    for(i = 0; i < 8; i += 2){
        var hex = "0123456789abcdef";
        var num1 = hex.indexOf(eagleeyeId[i]);
        var num2 = hex.indexOf(eagleeyeId[i + 1]);
        var value = num1 << 4;
        value |= num2;
        ipArr[i / 2] = value;
    }
    var aserver = ipArr.join(".");
    return {
        aserver: /^([0-9]{1,3}\.){3}[0-9]{1,3}/.test(aserver) ? aserver : null,
        traceTime: new Date(parseInt(eagleeyeId.substring(i, 13), 10)).toLocaleString("chinese", {
            hour12: false
        })
    };
}

 //# sourceMappingURL=parseEagleeyeId.js.map